/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_CreateInputs */

const en_users_create = /** @type {(inputs: Users_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create user`)
};

const pt_br2_users_create = /** @type {(inputs: Users_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar usuário`)
};

/**
* | output |
* | --- |
* | "Create user" |
*
* @param {Users_CreateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_create = /** @type {((inputs?: Users_CreateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_CreateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_create(inputs)
	return pt_br2_users_create(inputs)
});